import SideMenuOptionsTradeAP from './SideMenuOptionsTradeAP';

export default SideMenuOptionsTradeAP;
